/* Add lightbox to gallery images */
;(function () {
	lightbox('.kg-image-card > .kg-image[width][height], .kg-gallery-image > img')
})()

/* Responsive video in post content */
;(function () {
	const sources = [
		'.gh-content iframe[src*="youtube.com"]',
		'.gh-content iframe[src*="youtube-nocookie.com"]',
		'.gh-content iframe[src*="player.vimeo.com"]',
		'.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
		'.gh-content object',
		'.gh-content embed',
	]
	reframe(document.querySelectorAll(sources.join(',')))
})()

/* Infinite scroll pagination */
;(function () {
	if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
		pagination()
	}
})()

/* Responsive HTML table */
;(function () {
	const tables = document.querySelectorAll('.gh-content > table:not(.gist table)')
	const wrapper = document.createElement('div')
	wrapper.className = 'gh-table'

	tables.forEach(function (table) {
		table.parentNode.insertBefore(wrapper, table)
		wrapper.appendChild(table)
	})
})()
;(function () {
	const navLinks = document.querySelectorAll('nav a')

	navLinks.forEach((link) => {
		link.classList.remove('current')
		if (link.href === window.location.href) {
			link.classList.add('current')
		}
	})
})()

/* TOC Bot */
;(function () {
	tocbot.init({
		// Where to render the table of contents.
		tocSelector: '.gh-toc',
		// Where to grab the headings to build the table of contents.
		contentSelector: '.gh-content',
		// Which headings to grab inside of the contentSelector element.
		headingSelector: 'h2',
		// Ensure correct positioning
		hasInnerContainers: true,
	})
})()

/* Details */
;(function () {
	const viewport = window.matchMedia('(max-width: 768px)')
	const menus = document.querySelectorAll('footer details')

	const handleResize = (e) => {
		menus.forEach((menu) => {
			menu.open = e.matches ? false : true
		})
	}
	viewport.addEventListener('change', (e) => handleResize(e))
	handleResize(viewport)
})()
